/**
 * Google Analytics g-tag utility functions for tracking events
 */

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

/**
 * Track tour booking completion event
 * @param orderId - The order ID from the booking response
 * @param tourId - The tour ID
 * @param totalAmount - The total amount paid
 * @param currency - Currency code (default: VND)
 */
export function trackTourBookingComplete(
  orderId: string,
  tourId: string,
  totalAmount: number,
  currency: string = 'VND',
): void {
  //console.group('trackTourBookingComplete');
  //console.log('orderId', orderId);
  //console.log('tourId', tourId);
  //console.log('totalAmount', totalAmount);
  //console.log('currency', currency);
  //console.groupEnd();
  if (
    process.env.NODE_ENV === 'production' &&
    typeof window !== 'undefined' &&
    !window.location.hostname.includes('k2ktech') &&
    window.gtag
  ) {
    window.gtag('event', 'purchase', {
      transaction_id: orderId,
      value: totalAmount,
      currency: currency,
      items: [
        {
          item_id: tourId,
          item_name: 'Tour Booking',
          category: 'Tour',
          quantity: 1,
          price: totalAmount,
        },
      ],
    });

    // Additional custom event for tour booking
    window.gtag('event', 'tour_booking_complete', {
      event_category: 'Tour Booking',
      event_label: tourId,
      value: totalAmount,
      order_id: orderId,
    });
  }
}

/**
 * Track tour booking form submission
 * @param tourId - The tour ID
 * @param step - The current step in the booking process
 */
export function trackTourBookingStep(
  tourId: string,
  step: 'form_submit' | 'payment_selection' | 'confirmation',
): void {
  //console.group('trackTourBookingStep');
  //console.log('tourId', tourId);
  //console.log('step', step);
  //console.groupEnd();

  if (
    process.env.NODE_ENV === 'production' &&
    typeof window !== 'undefined' &&
    !window.location.hostname.includes('k2ktech') &&
    window.gtag
  ) {
    window.gtag('event', 'tour_booking_step', {
      event_category: 'Tour Booking',
      event_label: step,
      tour_id: tourId,
    });
  }
}

/**
 * Track button clicks in tour booking flow
 * @param buttonId - The button identifier
 * @param tourId - The tour ID
 * @param action - The action being performed
 */
export function trackTourBookingButtonClick(
  buttonId: string,
  tourId: string,
  action: string,
): void {
  //console.group('trackTourBookingButtonClick');
  //console.log('buttonId', buttonId);
  //console.log('tourId', tourId);
  //console.log('action', action);
  //console.groupEnd();

  if (
    process.env.NODE_ENV === 'production' &&
    typeof window !== 'undefined' &&
    !window.location.hostname.includes('k2ktech') &&
    window.gtag
  ) {
    window.gtag('event', 'tour_booking_button_click', {
      event_category: 'Tour Booking',
      event_label: buttonId,
      tour_id: tourId,
      action: action,
    });
  }
}
